<template>
  <div class="app-container">
    <el-form class="demo-ruleForm" label-position="top" size="medium">
      <el-form-item
        label="工位到期提醒时间设置（小时）"
        style="margin-bottom: 50px"
      >
        <el-input-number
          style="min-width: 202px"
          :precision="0"
          v-model="time"
          :min="0"
          :max="300"
          label="工位到期提醒时间设置"
        ></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button
          type="success"
          @click="editForm"
          v-if="roles.includes('/conf/set_station_remind_time')"
        >
          修改
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { set_station_remind_time } from "@/api/conf";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  data() {
    return {
      time: "",
    };
  },
  created() {
    this.getinfo();
  },
  mounted() {},
  methods: {
    getinfo() {
      set_station_remind_time({action:'get'}).then((res) => {
        if (res.data instanceof Array) {
          this.time = "";
        } else {
          this.time = res.data.info.value.time;
        }
      });
    },
    editForm() {
      if (this.time > 0) {
        set_station_remind_time({action:'set',time:this.time}).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
          });
        });
      } else {
        this.$message({
          message: "时间不能小于1小时",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  padding: 30px;
}
</style>
